/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {RCETextBlock} from './RCETextBlock'
import {RCETextBlockToolbar} from './RCETextBlockToolbar'
import {type RCETextBlockProps} from './types'

const RCETextBlockIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 0H15.3714V4.70571H13.4686V1.90286H9.74V16.0971H12.5686V18H4.77714V16.0971H7.60571V1.90286H3.90286V4.70571H2V0Z" fill="#273540"/>
</svg>`

export {RCETextBlock, RCETextBlockToolbar, RCETextBlockIcon, type RCETextBlockProps}
